import { BaseClass, IReshapeHandler, WaitInputMode } from "yfiles";
import addOrUpdateGroupNodesLabel from "../nodeRendering/addOrUpdateGroupNodesLabel";
export default class NonOverlapReshapeHandler extends BaseClass(IReshapeHandler) {
    constructor(graphComponentRef, node, handler) {
        super();
        this.graphComponentRef = graphComponentRef;
        this.node = node;
        this.handler = handler;
    }
    get bounds() {
        return this.handler.bounds;
    }
    initializeReshape(context) {
        this.handler.initializeReshape(context);
    }
    handleReshape(context, originalBounds, newBounds) {
        this.handler.handleReshape(context, originalBounds, newBounds);
    }
    async cancelReshape(context, originalBounds) {
        this.handler.cancelReshape(context, originalBounds);
    }
    async reshapeFinished(context, originalBounds, newBounds) {
        var _a;
        this.handler.reshapeFinished(context, originalBounds, newBounds);
        const waitInputMode = context.lookup(WaitInputMode.$class);
        if (waitInputMode) {
            waitInputMode.waiting = true;
        }
        if (this.node.tag) {
            this.node.tag = {
                ...this.node.tag,
                NodeWidth: newBounds.width,
                NodeHeight: newBounds.height
            };
        }
        (_a = this.node.labels) === null || _a === void 0 ? void 0 : _a.toArray().forEach(label => {
            var _a;
            ((_a = this.graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) && this.graphComponentRef.current.graph.remove(label);
        });
        addOrUpdateGroupNodesLabel(this.graphComponentRef, this.node);
        if (waitInputMode) {
            waitInputMode.waiting = false;
        }
    }
}
